// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__IQlpc","layout--internal":"Layout_layout--internal__KKJcI","main":"Layout_main__k2ohw"};